import createModel from 'utils/model'
import {
    info,
    update,
    publicKey,
    regeneratePublicKey,
    publicKeyVersion,
    updatePublicKeyVersion,
    getBindPhoneStatus,
    setBindPhoneStatus,
} from 'message-control/services/setting'

export default createModel({
    namespace: 'messageControl_setting',

    state: {
        msgSecret: null, // 消息会话secret
        whiteIPs: [], // 可信IP地址
        msgStatus: null, // 开启会话存档
        bindPhoneObj: null, // 扩展资料中-自动绑定订单手机号
        publicKey: '',
        publicKeyVersion: '',
    },

    effects: {
        *info({payload}, {call, put}) {
            const {data} = yield call(info, payload)
            yield put({
                type: 'setProperty',
                payload: {
                    msgSecret: data.msg_secret,
                    whiteIPs: data.white_ips,
                    msgStatus: data.status,
                },
            })
            return data
        },
        *update({payload}, {call}) {
            return yield call(update, payload)
        },
        *publicKey({payload}, {call, put}) {
            const {data} = yield call(publicKey, payload)
            yield put({
                type: 'setProperty',
                payload: {
                    publicKey: data,
                },
            })
        },
        *regeneratePublicKey({payload}, {call, put}) {
            const {data} = yield call(regeneratePublicKey, payload)
            yield put({
                type: 'setProperty',
                payload: {
                    publicKey: data,
                },
            })
        },

        *publicKeyVersion({payload}, {call, put}) {
            const {data} = yield call(publicKeyVersion, payload)
            yield put({
                type: 'setProperty',
                payload: {
                    publicKeyVersion: data,
                },
            })
        },

        *updatePublicKeyVersion({payload}, {call, put}) {
            yield call(updatePublicKeyVersion, payload)
            yield put({
                type: 'setProperty',
                payload: {
                    publicKeyVersion: payload.body.version,
                },
            })
        },

        // 获取扩展资料中-自动绑定订单手机号-状态
        *getBindPhoneStatus(xx, {call, put}) {
            const {data} = yield call(getBindPhoneStatus)
            yield put({
                type: 'setProperty',
                payload: {
                    bindPhoneObj: data,
                },
            })
            return data
        },

        // 变更扩展资料中-自动绑定订单手机号-状态
        *setBindPhoneStatus({payload}, {call}) {
            return yield call(setBindPhoneStatus, payload)
        },
    },
})
